export const MIN_QUERY_LENGTH = 2;

export const formatDate = (
  dateStr: string | null,
  options?: Partial<Intl.DateTimeFormatOptions>
): string | null => {
  if (!dateStr) return null;
  const defaults: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  };
  return new Date(dateStr).toLocaleDateString('en-US', {
    ...defaults,
    ...options,
  });
};

export const formatName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined
): string => {
  const parts = [firstName, lastName].filter(Boolean);
  return parts.length > 0 ? parts.join(' ') : 'Unknown';
};
